var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-navbar",
    {
      staticClass: "mobile-navbar",
      attrs: { toggleable: "md", type: "light", variant: "light" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between align-items-center w-100",
        },
        [
          _c("b-navbar-brand", [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("img", {
                staticClass: "mobile-logo",
                attrs: {
                  src: require("@/assets/images/logo_icon.png"),
                  alt: "Pitaya",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("b-navbar-toggle", {
            staticClass: "border-0",
            attrs: { target: "nav-collapse" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          staticClass: "no-transition",
          attrs: { id: "nav-collapse", "is-nav": "" },
        },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "mt-2" },
            [
              _vm._l(_vm.standardPageLinks, function (link) {
                return _c(
                  "b-nav-item",
                  { key: link.name, attrs: { to: link.to } },
                  [
                    _c("i", {
                      class: "fi-" + link.icon + " nav-icon",
                      staticStyle: { "margin-right": "8px" },
                    }),
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t(link.name)) + "\n      "
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _c("b-nav-item", { on: { click: _vm.handleLogout } }, [
                _c("i", {
                  staticClass: "fi-eject nav-icon",
                  staticStyle: { "margin-right": "8px" },
                }),
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("sidenav.logout")) + "\n      "
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }